import React from 'react';
import { Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import HelpModal from '../Modals/helpModal';
import { InfoTag } from '../shared/infoTag';

const DashboardApplicationsCard = ({ statisticsData, onSearch, onNavigate, showModal, isAdmin }) => {
  const { t } = useTranslation();

  return (
    <div className="card" data-tut="reactour__applications">
      <div className="card-body">
        <div className="row">
          <div className="col-6 text-center" style={{ cursor: 'pointer' }} onClick={() => onNavigate('/applications')}>
            <br />
            <em className="icon-envelope-letter fa-5x"></em>
            {statisticsData?.newApplications > 0 && (
              <div>
                <br />
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => onNavigate('/applications?onlyNew=1')}
                  className="badge badge-warning"
                >
                  <p className="m-1 h4">
                    <em className="fa fa-star mr-1"></em>
                    <strong>
                      {statisticsData?.newApplications} {t('applications.NEW_PL')}
                    </strong>
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="col-6">
            <h3 className="mt-0">
              {t('applications.APPLICATIONS')}
              &nbsp;
              <HelpModal
                purpose="applicationsHelp"
                showModal={showModal}
                onToggle={() => onNavigate('toggleHelpModal', 'applicationsHelp')}
              />
            </h3>
            <ul className="list-unstyled mb-0">
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="applicationJobTitle"
                    placeholder={t('jobs.SEARCH_BY_TITLE')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value, 'applicationJobTitle');
                      }
                    }}
                  />
                </div>
              </li>
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="applicationFirstName"
                    placeholder={t('applicants.SEARCH_BY_NAME')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value, 'applicationApplicantName');
                      }
                    }}
                  />
                </div>
              </li>
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="applicationLastName"
                    placeholder={t('applicants.SEARCH_BY_LAST_NAME')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value, 'applicationApplicantLastName');
                      }
                    }}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card-body bg-inverse" style={{ cursor: 'pointer' }} onClick={() => onNavigate('/applications')}>
        <div className="row text-center">
          <div className="col-2">
            <p className="m-0 h3">{statisticsData?.numApplications}</p>
            <p className="m-0">
              {t('applications.ALL')}
              &nbsp;
              <InfoTag id="allApplications" lng={t('i18n.language')} />
            </p>
          </div>
          <div className="col-2">
            <strong>
              <p className="m-0 h3">{statisticsData?.numApplicationsNormal}</p>
              <p className="m-0">
                {t('applications.NORMAL')}
                &nbsp;
                <InfoTag id="normalApplications" lng={t('i18n.language')} />
              </p>
            </strong>
          </div>
          <div className="col-2" id="colAutomaticFromJob">
            <p className="m-0 h3">{statisticsData?.numApplicationsForMostSuitableJobs}</p>
            <p className="m-0">
              {t('applications.JOB_AUTOMATIC')}
              &nbsp;
              <InfoTag id="jobAutomaticApplications" lng={t('i18n.language')} />
            </p>
          </div>
          <div className="col-3" id="colAutomaticFromApplicant">
            <p className="m-0 h3">{statisticsData?.numApplicationsForMostSuitableApplicant}</p>
            <p className="m-0">
              {t('applications.APPLICANT_AUTOMATIC')}
              &nbsp;
              <InfoTag id="applicantAutomaticApplications" lng={t('i18n.language')} />
            </p>
          </div>
          <div className="col-3" id="colAutomaticFromApplicant">
            <p className="m-0 h3">{statisticsData?.numApplicationsFromCompetences}</p>
            <p className="m-0">
              {t('applications.FROM_COMPETENCES')}
              &nbsp;
              <InfoTag id="applicationsFromCompetences" lng={t('i18n.language')} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardApplicationsCard;
